import { Star, StarLite, StarSuperLite } from '@apeiron/star'
import { useAccountContext } from '@apeiron/temp'
import { useWalletAddress } from '@apeiron/wallet'
import useGetStarSuperLite from '@src/hooks/graphql/useGetStarSuperLite'
import * as R from 'ramda'
import { useMemo } from 'react'

export const useStarHelper = (
  star?: Star | StarLite | StarSuperLite | null
): Hook => {
  const { account } = useAccountContext()

  const { compareAddress } = useWalletAddress()

  const isOwner = useMemo(() => {
    const starOwnerAddress = R.pathOr('', ['owner', 'walletAddress'], star)

    const userAddress = R.propOr('', 'walletAddress', account) as string

    return (
      !R.isEmpty(starOwnerAddress) &&
      !R.isEmpty(userAddress) &&
      compareAddress(starOwnerAddress, userAddress)
    )
  }, [account, compareAddress, star])

  return { isOwner }
}

export const useOnlineStarHelper = (starId: string): OnlinHook => {
  const { account, isLoggedIn } = useAccountContext()

  const address = R.propOr('', 'walletAddress', account) as string

  const { data: star } = useGetStarSuperLite(starId)

  // force star super lite to star
  const { isOwner } = useStarHelper(star as Star)

  return {
    isOwner,
    loading: isLoggedIn ? R.isEmpty(address) || R.isNil(star) : false
  }
}

type Hook = {
  isOwner: boolean
}

type OnlinHook = Hook & {
  loading: boolean
}
